import React from 'react';
import { ChangePasswordInfoForm } from '../../enums/ChangePasswordEnums';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Action } from '../../enums/GlobalEnums';

const ModalForChangePasswordInfo = ({
  showChangePasswordModalInfo,
  handleClose,
}) => {
  return (
    <Dialog
      open={showChangePasswordModalInfo}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {ChangePasswordInfoForm.changePasswordInfoFormTitle}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <p>
          Pošto ste zaboravili Vašu trenutnu lozinku molimo Vas da se u cilju
          postavljanja nove lozinke obratite administratoru aplikacije na
          sledeći mejl: info.office@gmail.com
        </p>
        <p>
          Potrebno je da u mejlu naznačite da želite promenu lozinke pošto ste
          Vašu trenutnu lozinku zaboravili i da navedete Vaše korisničko ime.
          Odgovor od adminstratora ćete dobiti u roku od 24h.
        </p>
        <p>
          Administrator će Vam poslati privremenu lozinku sa kojom ćete moći da
          se ulogujete u aplikaciju ali bi bilo preporučljivo da odmah nakon
          toga postavite svoju novu lozinku izborom opcije Promena lozinke iz
          menija koji se nalazi u gornjem desnom uglu.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          {Action.Close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalForChangePasswordInfo;
